import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  CheckboxInput,
  DatePicker,
  FormLabel,
  ModalError,
  ModalSuccess,
  NumberInput,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import Swal from "sweetalert2";
import { formatPayloadDate, getErrors } from "utils";

const ModalFormCostAllocation = ({
  open,
  onClose,
  optionComposer,
  getDataTable,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [optionContract, setOptionContract] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    date: moment(),
    composer_id: 0,
    contract_id: 0,
    start_date: null,
    end_date: null,
    cost_allocation_value: 0,
    threshold: 0,
    description: "",
    auto_deduction: false,
  });

  const handleChangePayload = (value, key) => {
    if (key === "contract_id") {
      const selectedContract = optionContract.find(item => item.id === value);
      if (selectedContract) {
        const { start_date, end_date } = selectedContract;
        setPayload(currentState => {
          return {
            ...currentState,
            start_date: moment(start_date),
            end_date: moment(end_date),
            contract_id: selectedContract?.id,
          };
        });
      }
    } else {
      setPayload(currentState => {
        return {
          ...currentState,
          [key]: value,
        };
      });
    }
  };

  const handleSubmit = async () => {
    const {
      date,
      start_date,
      end_date,
      auto_deduction,
      ...restPayload
    } = payload;

    const modifiedPayload = {
      ...restPayload,
      date: formatPayloadDate(date),
      start_date: formatPayloadDate(start_date),
      end_date: formatPayloadDate(end_date),
      auto_deduction,
    };
    setLoadingButton(true);
    try {
      setLoadingButton(true);
      await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/cost-allocation`,
        modifiedPayload,
        { headers }
      );
      onClose();
      ModalSuccess("Create Cost Allocation Success");
      getDataTable();
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };
  // const getTresshold = async () => {
  //   const url = `${hardBaseUrl}/publisher/cost-allocation/tresshold`;
  //   setLoadingButton(true);
  //   try {
  //     const response = await axios.get(url, { headers });
  //     const { data } = response?.data;
  //     handleChangePayload(data.tresshold, "tresshold");
  //   } catch (error) {
  //     ModalError(getErrors(error?.response));
  //   } finally {
  //     setLoadingButton(false);
  //   }
  // };

  const getContractData = async composer_id => {
    const url = `${hardBaseUrl}/publisher/transaction/v2/cost-allocation/contracts`;
    const payload = {
      composer_id,
    };
    setLoadingButton(true);
    try {
      const response = await axios.get(url, { headers, params: payload });
      const { data } = response?.data;
      const reconstructData = data?.map(item => ({
        ...item,
        id: item?.contract_id,
        label: item?.contract_number,
      }));
      setOptionContract(reconstructData || []);
      handleChangePayload(data?.tresshold, "threshold");
    } catch (error) {
      const statusCode = error?.response?.status;
      const swalConfig = {
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          container: "swal-container",
        },
      };

      if (statusCode === 404) {
        Swal.fire({
          ...swalConfig,
          title: "Endpoint Tidak Ditemukan",
          text:
            "Mohon maaf, server tidak dapat menemukan layanan yang diminta (Error 404).",
        });
      } else if (statusCode === 500) {
        Swal.fire({
          ...swalConfig,
          title: "Masalah Server",
          text:
            "Terjadi kesalahan internal pada server. Silakan coba beberapa saat lagi.",
        });
      } else {
        const errorMessage = getErrors(error?.response);
        Swal.fire({
          ...swalConfig,
          title: "Terjadi Kesalahan",
          text:
            typeof errorMessage === "string"
              ? errorMessage
              : "Terjadi kesalahan sistem.",
        });
      }
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    // getTresshold();
    if (payload?.composer_id) {
      getContractData(payload?.composer_id);
    }
  }, [payload.composer_id]);
  return (
    <Dialog fullWidth open={open} onClose={!loadingButton && onClose}>
      <DialogTitle>Create Cost Allocation</DialogTitle>
      <DialogContent dividers>
        <Grid container direction="column" rowSpacing={2}>
          {MockFieldForm?.map(
            ({ title, label, key, type, prefix, suffix, optional }, index) => {
              console.log({ key, value: payload[key] });
              return (
                <Grid item key={index}>
                  {title && <FormLabel label={title} required={!optional} />}
                  {type === "autocomplete" ? (
                    <AutoCompleteComponent
                      options={
                        key === "contract_id" ? optionContract : optionComposer
                      }
                      value={
                        (key === "contract_id"
                          ? optionContract
                          : optionComposer
                        )?.find(option => option?.id === payload?.[key]) || null
                      }
                      onChange={value => handleChangePayload(value, key)}
                      size="small"
                      width="100%"
                    />
                  ) : type === "checkbox" ? (
                    <CheckboxInput
                      label={label}
                      checked={payload?.[key]}
                      onChange={e =>
                        handleChangePayload(e?.target?.checked, key)
                      }
                      disabled={loadingButton}
                    />
                  ) : type === "date" ? (
                    <DatePicker
                      value={payload[key]}
                      onChange={date => handleChangePayload(date, key)}
                      disabled={loadingButton}
                    />
                  ) : type === "number" ? (
                    <NumberInput
                      value={payload?.[key]}
                      onChange={val => handleChangePayload(Number(val), key)}
                      startAdornment={prefix}
                      endAdornment={suffix}
                      disabled={loadingButton}
                    />
                  ) : type === "text" ? (
                    <TextInput
                      placeholder={title}
                      value={payload?.[key]}
                      autoComplete={`new-${key}`}
                      onChange={e => handleChangePayload(e?.target?.value, key)}
                      disabled={loadingButton}
                    />
                  ) : (
                    <TextInput
                      placeholder={title}
                      value={payload?.[key]}
                      autoComplete={`new-${key}`}
                      onChange={e => handleChangePayload(e?.target?.value, key)}
                      multiline
                      rows={4}
                      disabled={loadingButton}
                    />
                  )}
                </Grid>
              );
            }
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={loadingButton ? "Saving..." : "Save"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldForm = [
  {
    title: "Date",
    key: "date",
    type: "date",
  },
  {
    title: "Composer/ Author",
    key: "composer_id",
    type: "autocomplete",
  },
  {
    title: "Contract Number",
    key: "contract_id",
    type: "autocomplete",
  },
  {
    title: "Cost Allocation Period Date Start",
    key: "start_date",
    type: "date",
  },
  {
    title: "Cost Allocation Period Date End",
    key: "end_date",
    type: "date",
  },
  {
    title: "Cost Allocation Value",
    key: "cost_allocation_value",
    type: "number",
    prefix: "Rp",
  },
  {
    title: "Treshold",
    key: "threshold",
    type: "number",
    suffix: "%",
  },
  {
    title: "Description",
    key: "description",
    optional: true,
  },
  {
    label: "Automatically deducted by Sales Invoice",
    key: "auto_deduction",
    type: "checkbox",
  },
];
export default ModalFormCostAllocation;
